export enum FieldTypeEnum {
    /**
     * Select field, values prop contains a listz with values
     */
    SELECT = 0,
    /**
     * A date string
     */
    DATE = 1,
    /**
     * Text area field with multi line support
     * default max. 255 chars
     */
    TEXTAREA = 2,
    /**
     * Text field one line
     * default max. 20 chars
     */
    TEXT = 3,
    /**
     * Number field
     * can have max/min/step settings
     */
    NUMBER = 4,
    /**
     * A checkbox
     * can have code with short name string
     */
    CHECKBOX = 5,
    /**
     * This field is like a sub-section with fields inside
     */
    SUBFIELD = 6,
    /**
     * Field is a unit format field, units need to be fetched extra
     */
    UNIT = 7,
    /**
     * A select field with ax data
     * value is a string
     */
    AXSELECT = 8,
    /**
     * A select field with mymill unit data
     * value is a string
     */
    MYMILL_SELECT = 9,
    /**
     * A text field to search/filder other fields
     * e.g. to filter units by serial number
     * value is a string
     */
    SEARCH = 10,
    /**
     * A date string for a date time showing only the time
     * to select date time
     * Originally only for mymill import, but now also used
     * for all new data sets.
     */
    DATETIME = 11,

    /**
     * Only frontend internal use for filters
     */
    FILTER_DATE = 800,

    /**
     * Only frontend internal use if field has an action
     * Needs to handle add of sub-fields
     */
    ACTION_SUBFIELD = 999,

    UNKNOWN = 9999,
}
